import { WHITE_LABEL_PREFIX } from "@/constants/routes";
import { usePathname } from "next/navigation";
import { useCallback } from "react";

export function useWlPath() {
  const pathname = usePathname();
  const isWl = pathname.startsWith(`${WHITE_LABEL_PREFIX}/`);

  const toWlPath = useCallback(
    (path: string) => (isWl ? `${WHITE_LABEL_PREFIX}${path}` : path),
    [isWl],
  );

  return { isWl, toWlPath };
}
